import { NewsLetterTable } from "@/components/newsLetter/NewsLetterTable";

export default function NewsLetter() {
    return (
        <div className="flex items-center h-full pt-10 flex-col">
            <NewsLetterTable />
        </div>
    );
}
